var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{attrs:{"viewBox":"404.583 57.498 10 6","xmlns":"http://www.w3.org/2000/svg"}},[_c('g',{attrs:{"transform":"matrix(1, 0, 0, 1, 398.5830383300781, 52.49803161621094)"}},[_c('path',{attrs:{"d":"M6 11L16 11L11 5L6 11Z","fill":"#FEFEFE"}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }